import api from './api';
import {
  Bauteil, BauteilRequest, Elektroliste, ElektrolisteRequest, ElektrolisteStandardtexte,
} from '../types';

export const bauteilService = {
  getAll: async (): Promise<Bauteil[]> => (await api.get('/bauteile')).data,

  create: async (data: BauteilRequest): Promise<Bauteil> => (await api.post('/bauteile', data)).data,

  update: async (id: number, data: BauteilRequest): Promise<Bauteil> => (await api.put(`/bauteile/${id}`, data)).data,

  delete: async (id: number): Promise<void> => {
    await api.delete(`/bauteile/${id}`);
  },
};

export const elektrolisteService = {
  getByKundeId: async (kundeId: number): Promise<Elektroliste[]> =>
    (await api.get(`/elektrolisten/kunde/${kundeId}`)).data,

  getById: async (id: number): Promise<Elektroliste> => (await api.get(`/elektrolisten/${id}`)).data,

  create: async (data: ElektrolisteRequest): Promise<Elektroliste> => (await api.post('/elektrolisten', data)).data,

  update: async (id: number, data: ElektrolisteRequest): Promise<Elektroliste> =>
    (await api.put(`/elektrolisten/${id}`, data)).data,

  delete: async (id: number): Promise<void> => {
    await api.delete(`/elektrolisten/${id}`);
  },

  getStandardtexte: async (): Promise<ElektrolisteStandardtexte> =>
    (await api.get('/elektrolisten/standardtexte')).data,

  setStandardtexte: async (data: ElektrolisteStandardtexte): Promise<ElektrolisteStandardtexte> =>
    (await api.put('/elektrolisten/standardtexte', data)).data,

  downloadPdf: async (id: number): Promise<void> => {
    const response = await api.get(`/elektrolisten/${id}/pdf`, { responseType: 'blob' });
    const match = (response.headers['content-disposition'] || '').match(/filename[^;=\n]*=([^;\n]*)/);
    const dateiname = match?.[1]?.replace(/['"]/g, '').trim() || `Elektroliste_${id}.pdf`;

    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;
    link.download = dateiname;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  },
};

export default elektrolisteService;
